import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, Subject } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { Contract } from '../models/contract';
import { ServiceDirection } from '../models/service-direction';
import { AirlineIATA } from '../models/airline-iata';
import { Language } from '../models/language';
import { Relation } from '../models/relation';
import { ReservationStatus } from '../models/reservation-status';
import { Station } from '../models/station';

@Injectable({
  providedIn: 'root'
})
export class AppAttributesService {

  url = environment.url;
  // private stationSubject: Subject<any> = new Subject();
  private stationSubject: EventEmitter<any> = new EventEmitter();
  private contractTypeSubject: EventEmitter<any> = new EventEmitter();
  private flightDateSubject: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient) {
  }


  setflightDate(contract: string) {
    this.flightDateSubject.emit(contract);
  }
  getflightDate(): Observable<any> {
    return this.flightDateSubject;
  }


  setStation(station: string) {
    this.stationSubject.emit(station);
  }

  setContractType(contract: string) {
    // console.log('setComtract:-',contract);
    
    this.contractTypeSubject.emit(contract);
  }
  clearStation() {
    this.stationSubject.next();
  }

  getStation(): Observable<any> {
    return this.stationSubject;
  }

  getContractType(): Observable<any> {
    return this.contractTypeSubject;
  }

  setAppAttributes(appAttributes: AppAttributes) {
    localStorage.setItem('APP_ATTRIBUTES', JSON.stringify(appAttributes));
  }

  getAppAttributes(): AppAttributes {
    return JSON.parse(localStorage.getItem('APP_ATTRIBUTES'));
  }

  loadAttributes(userType: string, userId: number) {
    return this.http.get(`${this.url}` + '/attributes/app-attributes/' + userType + '/' + userId)
      .pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in getting app attributes'))),
      );
  }

  getServicesByStation(stationId: string) {
    return this.http.get(`${this.url}` + '/attributes/services/' + stationId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting services'))),
    );
  }

  getContracts() {
    return this.http.get(`${this.url}` + '/attributes/contracts').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting contracts'))),
    );
  }

  getContractsIdStation(resType: string, stationId: string) {
    let data = {
      contractType: resType,
      stationId: stationId
    }
    // console.log('page90:-',data);
    
    return this.http.post(`${this.url}` + '/attributes/getContractIds', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting services'))),
    );
  }
  getContractDetailsById(contractId: string, stationId: string) {
    let data = {
      contractId: contractId,
      stationId: stationId
    }
    return this.http.post(`${this.url}` + '/attributes/getContractDetailsById', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting services'))),
    );
  }


  //getContractServiceDetailsByDate
  getContractServiceDetailsByDate(contractType,contractId: string, stationId: string, flightDate: string) {
    let data = {
      contractId: contractId,
      stationId: stationId,
      date: flightDate,
      contractType : contractType
    }
    // console.log('data:-',data);
    
    return this.http.post(`${this.url}` + '/attributes/getContractServiceDetailsByDate', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting services'))),
    );
  }

  getFlightTypes() {
    return this.http.get(`${this.url}` + '/attributes/flight-types').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting flight types'))),
    );
  }



  getRetailServices(data) {
    return this.http.post(`${this.url}` + '/attributes/retailServices', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting retail  types'))),
    );
  }

  getAirlines() {
    return this.http.get(`${this.url}` + '/attributes/airlines').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting airlines'))),
    );
  }

  getLanguages() {
    return this.http.get(`${this.url}` + '/attributes/languages').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting languages'))),
    );
  }

  getGuardianRelations() {
    return this.http.get(`${this.url}` + '/attributes/guardian-relations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting guardian relations'))),
    );
  }

  getStationsByUser(userId) {
    return this.http.get(`${this.url}` + '/attributes/stations/' + `${userId}`).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting stations'))),
    );
  }

  getAllStations() {
    return this.http.get(`${this.url}` + '/attributes/stations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting stations'))),
    );
  }

  // getFlightDetails() {
  //   return this.http.get(`${this.url}` + '/attributes/getFlightDetails').pipe(tap(res => res),
  //     catchError(err => throwError(new Error('Issue in getting stations'))),
  //   );
  // }


  getUnAassignedTransactions() {
    return this.http.get(`${this.url}` + '/attributes/stations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting stations'))),
    );
  }

  getContractsWithRetail(): Contract[] {
    const attributes = this.getAppAttributes();
    const contracts: Contract[] = attributes.contracts || []; // Ensure contracts is an array

    // Create a new Contract instance for 'Retail-Web'
    const retailContract: Contract = {
      contractId: 'Retail-Web',
      description: 'Retail Web Description', // Provide a suitable description
      contractUdf1: '',  // Fill as necessary
      contractUdf2: '',
      contractUdf3: '',
      contractUdf4: '',
      lcbId: 0,         // Assign a suitable lcbId
      active: true,     // Set active status as needed
    };

    contracts.push(retailContract);
    return contracts;
  }
}

export interface AppAttributes {
  contracts: Contract[];
  serviceDirections: ServiceDirection[];
  airlines: AirlineIATA[];
  languages: Language[];
  relations: Relation[];
  statusList: ReservationStatus[];
  stations: Station[];
}
